// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginWith_container__2mpNa","icon":"LoginWith_icon___jAa5","text":"LoginWith_text__vi-oR"};